var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view home"},[_c('Header'),_c('div',{staticClass:"items-wrap"},[_c('CardsList',{ref:"cardsList",attrs:{"items":_vm.cardItemsList},on:{"scroll":_vm.onScroll}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }